import { Action } from '@ngrx/store';
export enum AnnouncementActionTypes {
  DEFAULT_STATE ='DEFAULT_STATE',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  ANNOUNCEMENT_SUCCESS  = 'ANNOUNCEMENT_SUCCESS',
  ANNOUNCEMENT_FAILURE  = 'ANNOUNCEMENT_FAILURE',
  VIEW_ANNOUNCEMENT = 'VIEW_ANNOUNCEMENT',
  VIEW_ANNOUNCEMENT_SUCCESS  = 'VIEW_ANNOUNCEMENT_SUCCESS',
  VIEW_ANNOUNCEMENT_FAILURE  = 'VIEW_ANNOUNCEMENT_SUCCESS',
  CHANGE_ANN_STATUS = 'CHANGE_ANN_STATUS',
  CHANGE_ANN_SUCCESS  = 'CHANGE_ANN_SUCCESS',
  CHANGE_ANN_FAILURE  = 'CHANGE_ANN_FAILURE',
  SINGLE_ANNOUNCEMENT = 'SINGLE_ANNOUNCEMENT',
  SINGLE_ANNOUNCEMENT_SUCCESS = 'SINGLE_ANNOUNCEMENT_SUCCESS',
  SINGLE_ANNOUNCEMENT_FAILURE = 'SINGLE_ANNOUNCEMENT_FAILURE',
  REQUEST_ANNOUNCEMENT= 'REQUEST_ANNOUNCEMENT',
  REQUEST_ANNOUNCEMENT_SUCCESS= 'REQUEST_ANNOUNCEMENT_SUCCESS',
  REQUEST_ANNOUNCEMENT_FAILURE= 'REQUEST_ANNOUNCEMENT_FAILURE',
  SEARCH_ANNOUNCEMENT= 'SEARCH_ANNOUNCEMENT',
  SEARCH_ANNOUNCEMENT_SUCCESS= 'SEARCH_ANNOUNCEMENT_SUCCESS',
  SEARCH_ANNOUNCEMENT_FAILURE= 'SEARCH_ANNOUNCEMENT_FAILURE',
  
  
}

export class Announcement implements Action {
  readonly type = AnnouncementActionTypes.ANNOUNCEMENT;
  constructor(public payload: any) {}  
}

export class ViewAnnouncement implements Action {
  readonly type = AnnouncementActionTypes.VIEW_ANNOUNCEMENT;
  constructor(public payload: any) {} 
}

export class ViewSingleAnnouncement implements Action {
  readonly type = AnnouncementActionTypes.VIEW_ANNOUNCEMENT;
  constructor(public payload: any) {} 
}

export class ChangeAnnStatus implements Action {
  readonly type = AnnouncementActionTypes.CHANGE_ANN_STATUS;
  constructor(public payload: any) {}
}

export class SingleAnnouncement implements Action {
  readonly type = AnnouncementActionTypes.SINGLE_ANNOUNCEMENT;
  constructor(public payload: any) {} 
}

export class RequestAnnouncement implements Action {
  readonly type = AnnouncementActionTypes.REQUEST_ANNOUNCEMENT;
  constructor(public payload: any) {} 
}

export class Search implements Action {
  readonly type = AnnouncementActionTypes.SEARCH_ANNOUNCEMENT;
  constructor(public payload: any) {} 
}

export class Default implements Action {
  readonly type = AnnouncementActionTypes.DEFAULT_STATE;
  constructor(public payload: any) {}
}

export class AnnouncementSuccess implements Action {
  readonly type = AnnouncementActionTypes.ANNOUNCEMENT_SUCCESS;
  constructor(public payload: any) {}
}

export class AnnouncementFailure implements Action {
  readonly type = AnnouncementActionTypes.ANNOUNCEMENT_FAILURE;
  constructor(public payload: any) {}
}

export class ViewAnnouncementSuccess implements Action {
  readonly type = AnnouncementActionTypes.VIEW_ANNOUNCEMENT_SUCCESS;
  constructor(public payload: any) {}
}

export class ViewAnnouncementFailure implements Action {
  readonly type = AnnouncementActionTypes.VIEW_ANNOUNCEMENT_FAILURE;
  constructor(public payload: any) {}
}



export class ChangeAnnSuccess implements Action {
  readonly type = AnnouncementActionTypes.CHANGE_ANN_SUCCESS;
  constructor(public payload: any) {}
}

export class ChangeAnnFailure implements Action {
  readonly type = AnnouncementActionTypes.CHANGE_ANN_FAILURE;
  constructor(public payload: any) {}
} 

export class SingleAnnouncementSuccess implements Action {
  readonly type = AnnouncementActionTypes.SINGLE_ANNOUNCEMENT_SUCCESS;
  constructor(public payload: any) {}
}

export class SingleAnnouncementFailure implements Action {
  readonly type = AnnouncementActionTypes.SINGLE_ANNOUNCEMENT_FAILURE;
  constructor(public payload: any) {}
}

export class RequestAnnouncementSuccess implements Action {
  readonly type = AnnouncementActionTypes.REQUEST_ANNOUNCEMENT_SUCCESS;
  constructor(public payload: any) {}
}

export class RequestAnnouncementFailure implements Action {
  readonly type = AnnouncementActionTypes.REQUEST_ANNOUNCEMENT_FAILURE;
  constructor(public payload: any) {}
}
export class SearchSuccess implements Action {
  readonly type = AnnouncementActionTypes.SEARCH_ANNOUNCEMENT_SUCCESS;
  constructor(public payload: any) {}
}

export class SearchFailure implements Action {
  readonly type = AnnouncementActionTypes.SEARCH_ANNOUNCEMENT_FAILURE;
  constructor(public payload: any) {}
}
export type All =
  | Announcement
  | AnnouncementSuccess
  | AnnouncementFailure
  | ViewAnnouncement
  | ViewAnnouncementSuccess
  | ViewAnnouncementFailure
  | ChangeAnnStatus
  | ChangeAnnSuccess
  | ChangeAnnFailure
  | SingleAnnouncement
  | SingleAnnouncementSuccess
  | SingleAnnouncementFailure
  | RequestAnnouncement
  | RequestAnnouncementSuccess
  | RequestAnnouncementFailure 
  | Search
  | SearchSuccess
  | SearchFailure 
  | Default;
